import React from 'react';
import C from '../colors';

export const PLATFORM_COLLECTION_PAUSED_TEXT = '平台代收款已暂停，新订单请线下收款。';
export const PLATFORM_COLLECTION_PAID_SAFE_TEXT = '已支付的款项及提现不受影响。';
export const PLATFORM_COLLECTION_COMING_TEXT = '新的收款方式正在接入，敬请期待。';
export const PLATFORM_COLLECTION_ARTICLE_URL = 'https://www.picsect.com/blog/platform-payment-tax/index.html';

// Platform collection is paused: it can no longer be switched on, but an order
// that already has it on may still be switched off.
export function canChangePlatformCollection(current, next) {
  return Boolean(current) && !next;
}

export default function PlatformCollectionPausedNotice() {
  return (
    <span data-testid="platform-collection-paused-notice">
      {PLATFORM_COLLECTION_PAUSED_TEXT}
      <strong style={{ color: C.ink2, fontWeight: 600 }}>{PLATFORM_COLLECTION_PAID_SAFE_TEXT}</strong>
      {PLATFORM_COLLECTION_COMING_TEXT}
      <a
        data-testid="platform-collection-paused-link"
        href={PLATFORM_COLLECTION_ARTICLE_URL}
        target="_blank"
        rel="noopener noreferrer"
        style={{ marginLeft: 4, color: C.ink2, textDecoration: 'underline', textUnderlineOffset: 2 }}
      >了解原因</a>
    </span>
  );
}
